import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/forms/Buttons/Button';

const RegistrationStatus = ({ registrationType, variant = 'desktop' }) => {
  const [t] = useTranslation();
  const isMobile = variant === 'mobile';

  if (registrationType === 'OPEN') {
    return (
      <>
        <p className={isMobile ? 'text-lg' : 'mb-4 text-2xl'}>
          {t('welcome.registration_period_with_date_1')}
          <span className='font-bold '>
            {t('welcome.registration_period_with_date_2')}{' '}
          </span>
          {t('welcome.registration_period_with_date_3')}
        </p>
        <Link to='/registration'>
          <Button
            className={
              isMobile
                ? 'h-14 rounded-xl font-light'
                : 'h-14 rounded-xl text-2xl font-light'
            }
            color='landing-blue'
            text={t('welcome.registration_to_exam')}
          />
        </Link>
        <p className={isMobile ? 'text-lg' : 'mt-4 text-xl'}>
          {t('welcome.have_account')}{' '}
          <Link to='/login'>
            <span className='font-bold text-primary hover:underline'>
              {t('welcome.login')}
            </span>
          </Link>
        </p>
      </>
    );
  }

  if (registrationType === 'PREOPEN') {
    return (
      <p
        className={
          isMobile
            ? 'flex flex-col px-4 text-center font-sfproBold'
            : 'mb-4 flex flex-col px-36 text-left font-sfproBold text-xl'
        }
      >
        <span className='text-blue-landing'>{t('welcome.registration_opens')}</span>
        <span
          className={
            isMobile ? 'mt-4 font-sfpro text-lg' : 'mt-4 font-sfpro text-xl'
          }
        >
          {t('welcome.have_account')}{' '}
          <Link to='/login'>
            <span className='font-bold text-primary hover:underline'>
              {t('welcome.login')}
            </span>
          </Link>
        </span>
      </p>
    );
  }

  if (registrationType === 'PRECLOSED') {
    return (
      <>
        <p
          className={
            isMobile
              ? 'flex flex-col px-4 text-center font-sfproBold'
              : 'mb-4 flex flex-col  text-left font-sfproBold text-xl'
          }
        >
          <span className='text-orange-600'>
            {t('welcome.registration_preclosed')}
          </span>
          <span
            className={
              isMobile ? 'mt-2 font-sfpro text-base' : 'mt-2 font-sfpro text-lg'
            }
          >
            {t('welcome.registration_preclosed_detail')}
          </span>
        </p>
        <Link to='/registration'>
          <Button
            className={
              isMobile
                ? 'h-14 rounded-xl font-light'
                : 'h-14 rounded-xl text-2xl font-light'
            }
            color='landing-blue'
            text={t('welcome.registration_to_exam')}
          />
        </Link>
        <p className={isMobile ? 'text-lg' : 'mt-4 text-xl'}>
          {t('welcome.have_account')}{' '}
          <Link to='/login'>
            <span className='font-bold text-primary hover:underline'>
              {t('welcome.login')}
            </span>
          </Link>
        </p>
      </>
    );
  }

  // CLOSED (default)
  return (
    <p
      className={
        isMobile
          ? 'flex flex-col px-4 text-center font-sfproBold'
          : 'mb-4 flex flex-col px-36 text-left font-sfproBold text-xl'
      }
    >
      <span className='text-red-600'>{t('welcome.registration_closed')}</span>
      <span
        className={
          isMobile ? 'mt-4 font-sfpro text-lg' : 'mt-4 font-sfpro text-xl'
        }
      >
        {t('welcome.have_account')}{' '}
        <Link to='/login'>
          <span className='font-bold text-primary hover:underline'>
            {t('welcome.login')}
          </span>
        </Link>
      </span>
    </p>
  );
};

export default RegistrationStatus;
